import React, { useEffect, useState } from 'react';
import { Type } from 'lucide-react';

/**
 * Elder Mode toggle — bumps root font-size by 20% for elder-friendly reading.
 * Persists in localStorage.
 */
export const ElderModeToggle = ({ className = '' }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('cn-elder-mode') === 'true';
    setEnabled(saved);
    if (saved) document.documentElement.classList.add('elder-mode');
  }, []);

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    localStorage.setItem('cn-elder-mode', String(next));
    document.documentElement.classList.toggle('elder-mode', next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      title={enabled ? 'Disable larger text mode' : 'Enable larger text mode'}
      aria-pressed={enabled}
      data-testid="elder-mode-toggle"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${
        enabled
          ? 'bg-cn-primary text-white border-cn-primary'
          : 'bg-white text-cn-text border-cn-border hover:bg-cn-bone-200 dark:bg-cn-ink-800 dark:hover:bg-cn-ink-700'
      } ${className}`}
    >
      <Type className="w-3.5 h-3.5" strokeWidth={2.2} />
      {enabled ? 'Large Text On' : 'Large Text'}
    </button>
  );
};

export default ElderModeToggle;
